
import { defineComponent, computed } from 'vue';
import BrazilFlag from './icons/BrazilFlag.vue';
import SpainFlag from './icons/SpainFlag.vue';
import UnitedStatesFlag from './icons/UnitedStatesFlag.vue';
import IconSpinner from './icons/IconSpinner.vue';
import IconPerson from './icons/IconPerson.vue';
import IconChevronDown from './icons/IconChevronDown.vue';
import IconChevronDownBlack from './icons/IconChevronDownBlack.vue';
import IconLogout from './icons/Logout.vue';
import BackPage from './icons/BackPage.vue';
import IconSearch from './icons/IconSearch.vue';
import IconVectorDark from './icons/IconVectorDark.vue';
import Menu from './icons/Menu.vue';
import Calendar from './icons/Calendar.vue';
import IconTrash from './icons/IconTrash.vue';

const icons: any = {
  brazil: BrazilFlag,
  spain: SpainFlag,
  eua: UnitedStatesFlag,
  spinner: IconSpinner,
  person: IconPerson,
  'chevron-down': IconChevronDown,
  'chevron-down-dark': IconChevronDownBlack,
  logout: IconLogout,
  back: BackPage,
  search: IconSearch,
  x: IconVectorDark,
  menu: Menu,
  calendar: Calendar,
  trash: IconTrash,
};

export default defineComponent({
  name: 'BaseIcon',

  props: {
    name: {
      type: String,
      required: true,
    },

    size: {
      type: [String, Number],
      default: '20px',
    },

    color: {
      type: String,
      default: '#000',
    },
  },

  setup(props) {
    const icon = computed(() => {
      return icons[props.name];
    });

    return { icon };
  },
});
